import { WebsocketState } from "types/websocket";
import {
  SET_ORDER_PNL,
  TOGGLE_ORDER_STATUS,
  TOGGLE_USER_LOGIN_STATUS,
} from "./actions";

export const initialState: WebsocketState = {
  orderStatus: false,
  userLoginStatus: false,
  orderPnl: {},
};

const websocketReducer = (state: WebsocketState, action: any) => {
  switch (action.type) {
    case SET_ORDER_PNL: {
      return {
        ...state,
        orderPnl: action?.payload?.orderPnl,
      };
    }
    case TOGGLE_ORDER_STATUS: {
      let newState = {
        ...state,
        orderStatus: !state.orderStatus,
      };

      return newState;
    }
    case TOGGLE_USER_LOGIN_STATUS: {
      return {
        ...state,
        userLoginStatus: !state.userLoginStatus,
      };
    }

    default:
      return state;
  }
};

export default websocketReducer;
